import { render, staticRenderFns } from "./imgF.vue?vue&type=template&id=77318f5f&scoped=true"
var script = {}
import style0 from "./imgF.vue?vue&type=style&index=0&id=77318f5f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77318f5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77318f5f')) {
      api.createRecord('77318f5f', component.options)
    } else {
      api.reload('77318f5f', component.options)
    }
    module.hot.accept("./imgF.vue?vue&type=template&id=77318f5f&scoped=true", function () {
      api.rerender('77318f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgF.vue"
export default component.exports